import {Grid} from "@mui/material"
import {checkVisibility} from "../../../misc/precondition-evaluation"
import Content from "../../../components/Content"
import React from "react"
import PropTypes from "prop-types"
import {muiGridPrototypes} from "./mui-grid-prototypes"

export const containerManagedFlexItemPrototype = [{
    key: "isContainer", type: "YESNO", label: "Ist Container", size: 3,
}, muiGridPrototypes.flexGrow, muiGridPrototypes.direction, muiGridPrototypes.justifyContent, muiGridPrototypes.alignItems, {
    key: "sizeType", type: "SELECT", label: "Size Type", size: 3, options: [{
        value: "grow", label: "grow",
    }, {
        value: "auto", label: "auto",
    }, {
        value: "basicNumber", label: "Basic Number",
    }, {
        value: "mediaBreakpoints", label: "Media Breakpoints",
    }],
}, {
    key: "basicNumber", type: "INTEGER", label: "Basic Number", size: 12,
}, {
    key: "mediaBreakpointXs", type: "INTEGER", label: "Media Breakpoint: XS", size: "grow",
}, {
    key: "mediaBreakpointSm", type: "INTEGER", label: "Media Breakpoint: SM", size: "grow",
}, {
    key: "mediaBreakpointMd", type: "INTEGER", label: "Media Breakpoint: MD", size: "grow",
}, {
    key: "mediaBreakpointLg", type: "INTEGER", label: "Media Breakpoint: LG", size: "grow",
}, {
    key: "mediaBreakpointXl", type: "INTEGER", label: "Media Breakpoint: XL", size: "grow",
}]

const getSizeValue = (size) => {
    if (size === undefined) return undefined
    const castedSize = Number.parseInt(size)
    if (castedSize >= 1 && castedSize <= 12) return castedSize
    return undefined
}

const buildSize = (containerProps) => {
    const {sizeType, basicNumber} = containerProps
    if (sizeType === undefined || sizeType === "grow") {
        return "grow"
    } else if (sizeType === "auto") {
        return "auto"
    } else if (sizeType === "basicNumber") {
        return basicNumber ? Number.parseInt(basicNumber) : 12
    } else if (sizeType === "mediaBreakpoints") {
        return {
            xs: getSizeValue(containerProps.mediaBreakpointXs),
            sm: getSizeValue(containerProps.mediaBreakpointSm),
            md: getSizeValue(containerProps.mediaBreakpointMd),
            lg: getSizeValue(containerProps.mediaBreakpointLg),
            xl: getSizeValue(containerProps.mediaBreakpointXl),
        }
    }
    return undefined
}

export const ContainerManagedFlexItem = ({container, disabled, getDataFromPointer}) => {
    return <Grid
        spacing={container.isContainer && `${container?.containerSpacing}px`}
        container={container.isContainer ?? false}
        direction={container?.direction}
        justifyContent={container?.justifyContent}
        alignItems={container?.alignItems}
        size={buildSize(container)}
        flexGrow={container.flexGrow}
        minHeight={container.minHeight}
        minWidth={container.minWidth}
        maxWidth={container.maxWidth}
    >
        {container.children.map((widget) => (checkVisibility(widget, getDataFromPointer) &&
            <Content
                key={widget.id}
                child={widget}
                disabled={disabled}
            />))}
    </Grid>
}

ContainerManagedFlexItem.propTypes = {
    container: PropTypes.shape({
        children: PropTypes.array,
        direction: PropTypes.string,
        justifyContent: PropTypes.string,
        alignItems: PropTypes.string,
        wrap: PropTypes.string,
        sizeType: PropTypes.string,
        basicNumber: PropTypes.string,
        mediaBreakpointXs: PropTypes.string,
        mediaBreakpointSm: PropTypes.string,
        mediaBreakpointMd: PropTypes.string,
        mediaBreakpointLg: PropTypes.string,
        mediaBreakpointXl: PropTypes.string,
        isContainer: PropTypes.bool,
        flexGrow: PropTypes.string,
    }),
    disabled: PropTypes.bool,
    getDataFromPointer: PropTypes.func,
}